<template>
    <div class="inside-page">
        <van-nav-bar
            :title="projectDetail.projectName ? projectDetail.projectName : '-'"
            left-text="返回"
            @click-left="back"
            fixed
            left-arrow
            :right-text="(projectManagement || user.id==projectDetail.inchargerId || user.id==projectDetail.creatorId || canModParticipator) ? '编辑项目' : ''"
            @click-right="openProject()"
        />
        <div class="content">

            <!-- ===== 基本信息卡片 ===== -->
            <div class="section-card">
                <div class="section-header">
                    <van-icon name="records" class="section-icon" />
                    <span class="section-title">基本信息</span>
                </div>
                <div class="info-list">
                    <div class="info-item" v-if="projectDetail.projectName">
                        <span class="info-label">项目名称</span>
                        <span class="info-value">{{ projectDetail.projectName }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">{{ user.companyId == '7030' ? '项目令号' : '项目编号' }}</span>
                        <span class="info-value">{{ projectDetail.projectCode || '-' }}</span>
                    </div>
                    <div class="info-item" v-if="projectDetail.categoryName">
                        <span class="info-label">项目分类</span>
                        <span class="info-value">{{ projectDetail.categoryName }}</span>
                    </div>
                    <div class="info-item" v-if="projectDetail.currentStageName">
                        <span class="info-label">当前阶段</span>
                        <span class="info-value">
                            <van-tag type="primary" plain size="small">{{ projectDetail.currentStageName }}</van-tag>
                        </span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">状态</span>
                        <span class="info-value">
                            <span class="status-badge" :class="getStatusClass(projectDetail.status)">{{ getStatusLabel(projectDetail.status) }}</span>
                        </span>
                    </div>
                    <div class="info-item" v-if="projectDetail.projectDesc">
                        <span class="info-label">项目描述</span>
                        <span class="info-value">{{ projectDetail.projectDesc }}</span>
                    </div>
                    <div class="info-item" v-if="user.timeType.projectWithDept == 1 && projectDetail.departmentName">
                        <span class="info-label">所属部门</span>
                        <span class="info-value">
                            <span v-if="user.userNameNeedTranslate != 1">{{ projectDetail.departmentName }}</span>
                            <span v-else><TranslationOpenDataText type='departmentName' :openid='projectDetail.departmentName'></TranslationOpenDataText></span>
                        </span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">项目级别</span>
                        <span class="info-value">{{ levelToText(projectDetail.level) || '-' }}</span>
                    </div>
                    <div class="info-item" v-if="user.company.packageEngineering == 0">
                        <span class="info-label">完成度</span>
                        <span class="info-value progress-wrap">
                            <van-progress :percentage="projectDetail.progress || 0" :pivot-text="(projectDetail.progress || 0) + '%'" color="#4a90e2" track-color="#e8f0fb" stroke-width="6" style="flex:1;" />
                        </span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">创建日期</span>
                        <span class="info-value">{{ projectDetail.createDate || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">计划开始</span>
                        <span class="info-value">{{ projectDetail.planStartDate || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">计划结束</span>
                        <span class="info-value">{{ projectDetail.planEndDate || '-' }}</span>
                    </div>
                    <div class="info-item" v-if="projectDetail.finishDate">
                        <span class="info-label">实际完成</span>
                        <span class="info-value">{{ projectDetail.finishDate }}</span>
                    </div>
                    <div class="info-item" v-if="user.timeType.outputValueStatus == 1">
                        <span class="info-label">项目产值</span>
                        <span class="info-value">￥{{ projectDetail.outputValue != null ? projectDetail.outputValue.toFixed(2) : '-' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">合同金额</span>
                        <span class="info-value">￥{{ projectDetail.contractAmount != null ? projectDetail.contractAmount.toFixed(2) : '-' }}</span>
                    </div>
                </div>
            </div>

            <!-- ===== 随访信息卡片 ===== -->
            <div class="section-card" v-if="projectDetail.application || projectDetail.instrumentOrDrug != null || projectDetail.experimentalSample != null || projectDetail.visitRemind != null || projectDetail.everyFollowUpNum != null || projectDetail.visitNum">
                <div class="section-header">
                    <van-icon name="notes-o" class="section-icon" />
                    <span class="section-title">随访信息</span>
                </div>
                <div class="info-list">
                    <div class="info-item" v-if="projectDetail.application">
                        <span class="info-label">申办方</span>
                        <span class="info-value">{{ projectDetail.application }}</span>
                    </div>
                    <div class="info-item" v-if="projectDetail.instrumentOrDrug != null">
                        <span class="info-label">器械药品</span>
                        <span class="info-value">{{ getInstrumentLabel(projectDetail.instrumentOrDrug) }}</span>
                    </div>
                    <div class="info-item" v-if="projectDetail.experimentalSample != null">
                        <span class="info-label">样本量</span>
                        <span class="info-value">{{ projectDetail.experimentalSample }}</span>
                    </div>
                    <div class="info-item" v-if="projectDetail.everyFollowUpNum != null">
                        <span class="info-label">标准随访数</span>
                        <span class="info-value">{{ projectDetail.everyFollowUpNum }}</span>
                    </div>
                    <div class="info-item" v-if="projectDetail.visitRemind != null">
                        <span class="info-label">随访提醒</span>
                        <span class="info-value">{{ getVisitRemindLabel(projectDetail.visitRemind) }}</span>
                    </div>
                    <div class="info-item" v-if="projectDetail.visitNum">
                        <span class="info-label">随访模块数</span>
                        <span class="info-value">{{ projectDetail.visitNum }}</span>
                    </div>
                </div>
            </div>

            <!-- ===== 相关人员卡片 ===== -->
            <div class="section-card">
                <div class="section-header">
                    <van-icon name="manager-o" class="section-icon" />
                    <span class="section-title">相关人员</span>
                </div>
                <div class="info-list">
                    <div class="info-item" v-if="projectDetail.inchargerName">
                        <span class="info-label">项目经理</span>
                        <span class="info-value">
                            <span v-if="user.userNameNeedTranslate == '1'"><TranslationOpenDataText type='userName' :openid='projectDetail.inchargerName'></TranslationOpenDataText></span>
                            <span v-else>{{ projectDetail.inchargerName }}</span>
                        </span>
                    </div>
                    <div class="info-item" v-if="user.timeType.reportAuditType == 0 || user.timeType.reportAuditType == 4">
                        <span class="info-label">日报审核人</span>
                        <span class="info-value">
                            <template v-if="projectDetail.auditorList && projectDetail.auditorList.length">
                                <span v-for="(item, index) in projectDetail.auditorList" :key="item.id">
                                    <span v-if="index != 0">，</span>
                                    <span v-if="user.userNameNeedTranslate != '1'">{{ item.auditorName }}</span>
                                    <span v-else><TranslationOpenDataText type='userName' :openid='item.auditorName'></TranslationOpenDataText></span>
                                </span>
                            </template>
                            <span v-else>-</span>
                        </span>
                    </div>
                    <div class="info-item" v-if="projectDetail.isPublic == 0 && projectDetail.participationList && projectDetail.participationList.length">
                        <span class="info-label">参与人</span>
                        <span class="info-value">
                            <span v-for="(item, index) in projectDetail.participationList" :key="item.id">
                                <span v-if="index != 0">，</span>
                                <span v-if="user.userNameNeedTranslate != '1'">{{ item.name }}</span>
                                <span v-else><TranslationOpenDataText type='userName' :openid='item.name'></TranslationOpenDataText></span>
                            </span>
                        </span>
                    </div>
                    <div class="info-item" v-if="projectDetail.creatorName">
                        <span class="info-label">创建人</span>
                        <span class="info-value">
                            <span v-if="user.userNameNeedTranslate == '1'"><TranslationOpenDataText type='userName' :openid='projectDetail.creatorName'></TranslationOpenDataText></span>
                            <span v-else>{{ projectDetail.creatorName }}</span>
                        </span>
                    </div>
                </div>
            </div>

            <!-- ===== 研究中心与CRC卡片 ===== -->
            <div class="section-card" v-if="projectDetail.projectHospitalList && projectDetail.projectHospitalList.length">
                <div class="section-header">
                    <van-icon name="location-o" class="section-icon" />
                    <span class="section-title">研究中心与参与人CRC</span>
                </div>
                <div
                    v-for="(hospital, hIdx) in projectDetail.projectHospitalList"
                    :key="hospital.id"
                    class="hospital-card"
                >
                    <div class="hospital-card-header">
                        <div class="hospital-index">中心 {{ hIdx + 1 }}</div>
                        <div class="hospital-name">
                            <van-icon name="location-o" class="hospital-icon" />
                            {{ hospital.hospitalName }}
                        </div>
                        <van-tag v-if="hospital.progressStatus" plain type="primary" size="small" class="hospital-status">{{ hospital.progressStatus }}</van-tag>
                    </div>
                    <div class="hospital-info">
                        <div class="hospital-info-item" v-if="hospital.planCasesNumber != null">
                            <span class="hospital-info-label">计划例数</span>
                            <span class="hospital-info-value">{{ hospital.planCasesNumber }}</span>
                        </div>
                        <div class="hospital-info-item" v-if="hospital.proHosParticipatorList && hospital.proHosParticipatorList.length">
                            <span class="hospital-info-label">参与人CRC</span>
                            <span class="hospital-info-value">
                                <span v-for="(crc, crcIdx) in hospital.proHosParticipatorList" :key="crc.id">
                                    <span v-if="crcIdx != 0">，</span>
                                    <span v-if="user.userNameNeedTranslate == '1'">
                                        <TranslationOpenDataText type='userName' :openid='crc.userName'></TranslationOpenDataText>
                                    </span>
                                    <span v-else>{{ crc.userName }}</span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: JSON.parse(localStorage.userInfo),
            projectManagement: false,
            projectId: JSON.parse(sessionStorage.projectId),
            projectDetail: {},
            canModParticipator: false,
            canOnlyModParticipator: false,

            info: {
                statusText: ['全部', '进行中', '已完成', '撤销', '已暂停', '结项申请中'],
                levelList: [],
                levelText: ['全部', '正常', '紧急', '重要', '重要且紧急'],
            },

            instrumentMap: { 1: '药品', 2: '器械', 3: '试剂盒IVD' },
            visitRemindMap: { 1: '提前1天', 3: '提前3天', 7: '提前7天', 14: '提前14天', 30: '提前30天' },
        }
    },
    mounted() {
        for (let i in this.user.functionList) {
            if (this.user.functionList[i].name == '管理全部项目') {
                this.projectManagement = true;
            }
            if (this.user.functionList[i].name == '编辑项目参与人') {
                this.canModParticipator = true;
            }
        }
        this.getProjectDetail();
        this.getLevelList();
    },
    methods: {
        back() {
            history.back();
        },
        getStatusLabel(status) {
            const map = { 0: '全部', 1: '进行中', 2: '已完成', 3: '已撤销', 4: '已暂停', 5: '结项申请中' };
            return map[status] || '-';
        },
        getStatusClass(status) {
            const map = { 1: 'status-active', 2: 'status-done', 3: 'status-cancel', 4: 'status-pause', 5: 'status-closing' };
            return map[status] || 'status-active';
        },
        getInstrumentLabel(val) {
            return this.instrumentMap[val] || '-';
        },
        getVisitRemindLabel(val) {
            return this.visitRemindMap[val] || '-';
        },
        levelToText(lev) {
            if (this.user.timeType.projectLevelState == 1) {
                const found = this.info.levelList.filter(item => item.id == lev);
                if (found.length == 0) return this.info.levelText[lev] || '-';
                return found[0].projectLevelName;
            } else {
                return this.info.levelText[lev] || '-';
            }
        },
        openProject() {
            if (this.projectManagement || this.user.id == this.projectDetail.inchargerId || this.user.id == this.projectDetail.creatorId || this.canModParticipator) {
                if (this.canModParticipator && !this.projectManagement && this.user.id != this.projectDetail.inchargerId && this.user.id != this.projectDetail.creatorId) {
                    this.canOnlyModParticipator = true;
                }
                this.$router.push({ path: "/editProject", query: { canOnlyModParticipator: this.canOnlyModParticipator ? '1' : '0' } });
            }
        },
        getProjectDetail() {
            this.$axios.post("/project/detail", { id: this.projectId })
            .then(res => {
                if (res.code == "ok") {
                    this.projectDetail = res.data;
                } else {
                    this.$toast.fail('获取失败');
                }
            }).catch(err => { this.$toast.clear(); console.log(err); });
        },
        getLevelList() {
            this.$axios.post("/project-level/list", {})
            .then(res => {
                if (res.code == "ok") {
                    this.info.levelList = res.data;
                } else {
                    this.$toast.fail('获取失败');
                }
            }).catch(err => { this.$toast.clear(); console.log(err); });
        },
    },
}
</script>

<style lang="less" scoped>
.inside-page {
    min-height: 100vh;
    background: #f0f4f8;
}
.content {
    margin-top: 46px;
    padding: 12px 12px 24px;
    overflow: auto;
}

.section-card {
    background: #fff;
    border-radius: 12px;
    margin-bottom: 12px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.06);
    overflow: hidden;
}

.section-header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: linear-gradient(135deg, #f0f7ff 0%, #fff 100%);
    border-bottom: 1px solid #f0f0f0;
    .section-icon {
        font-size: 18px;
        color: #4a90e2;
        margin-right: 8px;
    }
    .section-title {
        font-size: 15px;
        font-weight: 600;
        color: #1a1a1a;
    }
}

.info-list {
    padding: 4px 0;
}

.info-item {
    display: flex;
    align-items: flex-start;
    padding: 10px 16px;
    border-bottom: 1px solid #f8f8f8;
    &:last-child { border-bottom: none; }
    .info-label {
        font-size: 13px;
        color: #999;
        width: 80px;
        flex-shrink: 0;
        padding-top: 1px;
    }
    .info-value {
        font-size: 14px;
        color: #333;
        flex: 1;
        word-break: break-all;
        &.progress-wrap {
            display: flex;
            align-items: center;
        }
    }
}

.status-badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 500;
    &.status-active { background: #e6f7ff; color: #1890ff; }
    &.status-done { background: #f6ffed; color: #52c41a; }
    &.status-cancel { background: #fff1f0; color: #ff4d4f; }
    &.status-pause { background: #fff7e6; color: #fa8c16; }
    &.status-closing { background: #f9f0ff; color: #722ed1; }
}

// 研究中心卡片
.hospital-card {
    border-bottom: 1px solid #f0f0f0;
    &:last-child { border-bottom: none; }
}

.hospital-card-header {
    display: flex;
    align-items: center;
    padding: 10px 16px 6px;
    gap: 8px;
    .hospital-index {
        font-size: 12px;
        color: #4a90e2;
        font-weight: 600;
        background: #e6f7ff;
        padding: 2px 8px;
        border-radius: 8px;
        flex-shrink: 0;
    }
    .hospital-name {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        flex: 1;
        display: flex;
        align-items: center;
        .hospital-icon {
            color: #4a90e2;
            margin-right: 4px;
            font-size: 14px;
        }
    }
    .hospital-status {
        flex-shrink: 0;
    }
}

.hospital-info {
    padding: 4px 16px 10px 16px;
    .hospital-info-item {
        display: flex;
        align-items: flex-start;
        padding: 4px 0;
        .hospital-info-label {
            font-size: 12px;
            color: #999;
            width: 70px;
            flex-shrink: 0;
        }
        .hospital-info-value {
            font-size: 13px;
            color: #555;
            flex: 1;
        }
    }
}
</style>
